import { render } from "./ModalDrawer.vue?vue&type=template&id=a21b87b4&scoped=true"
import script from "./ModalDrawer.vue?vue&type=script&lang=js"
export * from "./ModalDrawer.vue?vue&type=script&lang=js"

import "./ModalDrawer.vue?vue&type=style&index=0&id=a21b87b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21b87b4"]])

export default __exports__